exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#advisor-dashboard-container{padding:25px}.advisor-close{padding:25px 50px 25px 100px !important}.sidebar-open{margin-left:250px}.sidebar-close{margin-left:4vw}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Layout/Layout.scss
// module id = 7539
// module chunks = 101